import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { tokenStore } from '../shared/api/token-store';
import { AppShell } from '../widgets/app-shell';

export const Route = createFileRoute('/_shell')({
  beforeLoad: ({ location }) => {
    if (tokenStore.access() ?? tokenStore.refresh()) return;
    throw redirect({ to: '/sign-in', search: { next: location.href } });
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
